module.exports = __webpack_public_path__ + "img/healthcare-section4.93b02cc5.svg";